import { useMemo } from 'react';
import { keyHash } from '@mssgme/helpers';

export function useMergedStyles(baseStyle, additionalStyle) {
    return useMemo(
        () => (baseStyle && additionalStyle) ? { ...baseStyle, ...additionalStyle } : (baseStyle || additionalStyle),
        [keyHash(baseStyle), keyHash(additionalStyle)]
    );
}
